import { ApiSuccessResponse, IApiService } from '../services/api_service';

export const itds = (siteApi: IApiService) => ({
  post: (data): Promise<ApiSuccessResponse<any>> => {
    return siteApi.post('/itds', data);
  },
  delete: (account, data): Promise<ApiSuccessResponse<any>> => {
    return siteApi.delete(`/itds/${account}`, { data });
  }
});
